import Toolbar from "./Toolbar"

export default {
	Toolbar,
}



// WEBPACK FOOTER //
// ./src/components/classtop-react-big-calendar/index.js